
export const COMPANY_BANK_SERVICE = {
  BUY_REMITTANCE_REQUEST: 'BUY_REMITTANCE_REQUEST',
  BUY_REMITTANCE_SUCCESS: 'BUY_REMITTANCE_SUCCESS',
  BUY_REMITTANCE_FAIL: 'BUY_REMITTANCE_FAIL'
};
